import { render, staticRenderFns } from "./MainFrameCreatDayTrip.vue?vue&type=template&id=522dea3d"
import script from "./MainFrameCreatDayTrip.vue?vue&type=script&lang=js"
export * from "./MainFrameCreatDayTrip.vue?vue&type=script&lang=js"
import style0 from "./MainFrameCreatDayTrip.vue?vue&type=style&index=0&id=522dea3d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports